module.exports = __webpack_public_path__ + "static/crete-your-own-heidi-header-73c0a19942793b6ff8df56c6d91cbfc6.jpg";